/** @jsxImportSource preact */
import {
  JETSTAR_AGENT_HUB_MESSAGE,
  JETSTAR_CANCELLATION_NOTES,
  JETSTAR_CANCELLATION_RULES,
} from './jetstar-cancellation-rules'

export function JetstarCancellationRules() {
  return (
    <div className="mt-1 space-y-2">
      <p className="text-sm text-red-700">{JETSTAR_AGENT_HUB_MESSAGE}</p>
      <div className="overflow-x-auto bg-white rounded border border-red-200">
        <table className="min-w-full text-xs text-gray-800">
          <thead className="bg-red-100 text-left text-red-900">
            <tr>
              <th className="px-2 py-1">Bundle</th>
              <th className="px-2 py-1">Can cancel?</th>
              <th className="px-2 py-1">Customer gets back</th>
              <th className="px-2 py-1">Fee</th>
              <th className="px-2 py-1">Cutoff</th>
            </tr>
          </thead>
          <tbody>
            {JETSTAR_CANCELLATION_RULES.map(rule => (
              <tr
                key={rule.bundle}
                className="border-t border-red-100"
              >
                <td className="px-2 py-1 font-medium">{rule.bundle}</td>
                <td className="px-2 py-1">{rule.canCancel}</td>
                <td className="px-2 py-1">{rule.getsBack}</td>
                <td className="px-2 py-1">{rule.fee}</td>
                <td className="px-2 py-1">{rule.cutoff}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ul className="list-disc pl-5 text-xs text-red-700 space-y-0.5">
        {JETSTAR_CANCELLATION_NOTES.map(note => (
          <li key={note}>{note}</li>
        ))}
      </ul>
    </div>
  )
}
